export default __webpack_public_path__ + "static/media/No.6-0.16422374.jpg";